import { cn } from '@/lib/utils'

interface TechnicianReferenceBadgeProps {
  value: string
  className?: string
  labelClassName?: string
  showAccent?: boolean
}

// Compact plate-style badge used for technician vehicle references.
export function TechnicianReferenceBadge({
  value,
  className,
  labelClassName,
  showAccent = true,
}: TechnicianReferenceBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex w-fit items-stretch overflow-hidden rounded-lg border border-[#e7e9ef] bg-[#f8f9fb] shadow-[0_1px_2px_rgba(23,26,32,0.05)]',
        className
      )}
    >
      {showAccent ? (
        <span
          className='w-1.5 shrink-0 self-stretch bg-[#356ae6]'
          aria-hidden='true'
        />
      ) : null}
      <span
        className={cn(
          'inline-flex items-center px-3 py-2 text-sm font-semibold leading-none tracking-[0.02em] text-[#3d434e]',
          labelClassName
        )}
      >
        {value}
      </span>
    </span>
  )
}

export default TechnicianReferenceBadge
